import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';
import userPlaceholder from '../../assets/user-placeholder.png';
import Rating from '../Rating';

const ReviewCard = ({
  photo = undefined,
  name = undefined,
  title = undefined,
  feedbackText,
  textTitle = undefined,
  rate,
  address = undefined,
}) => (
  <div className={styles.reviewCard}>
    <header>
      <picture>
        <img
          src={photo?.sizes?.thumbnail?.url || photo?.url || userPlaceholder}
          alt={name}
          width="45"
          height="45"
          loading="lazy"
          decoding="async"
        />
      </picture>
      <div className={styles.info}>
        {name && <h5>{name}</h5>}
        {title && <p>{title}</p>}
      </div>
    </header>
    {address && <div className={styles.address}>{address}</div>}
    {rate && (
      <div className={styles.rating}>
        <Rating rating={rate} />
      </div>
    )}
    <div className={styles.text}>
      {textTitle && (
        <p>
          <strong>{textTitle}</strong>
        </p>
      )}
      {feedbackText}
    </div>
  </div>
);

ReviewCard.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  photo: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    sizes: PropTypes.shape({
      thumbnail: PropTypes.shape({
        url: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
      }),
    }),
  }),
  rate: PropTypes.number.isRequired,
  feedbackText: PropTypes.string.isRequired,
  textTitle: PropTypes.string,
  address: PropTypes.string,
};

export default ReviewCard;
